import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { splitLeadingEmoji } from '../utils/emoji.ts';
import { nullableDate } from '../utils/format.ts';
import { Product } from './product.ts';

export class Collection extends Model<Schemas['collections'], Models> {
    get emoji() {
        return splitLeadingEmoji(this.name).emoji;
    }

    get title() {
        return splitLeadingEmoji(this.name).text;
    }

    shareUrl(product?: Product | null): string {
        const slug =
            product?.slug ||
            this.product?.slug ||
            this.item?.packs?.flatMap((pack) => pack.products || []).find(Boolean)?.slug;

        return slug
            ? new URL(`/${slug}/collections/${this.id}`, import.meta.env.VITE_BASE_URL).href
            : '';
    }

    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get updatedAtDate() {
        return nullableDate(this.updatedAt);
    }

    get itemCountString() {
        const count = Object.values(this.itemCounts || {}).reduce(
            (total, value) => total + Number(value || 0),
            0,
        );

        if (!count) return 'No items';

        return `${count} item${count === 1 ? '' : 's'}`;
    }
}
